import { device } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { App } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'

const clientIsEnabled = (params: {
  clientConfiguration?: App
  device: typeof device
}) => {
  const { clientConfiguration = { enabled: false }, device = {} } = params || {}
  const isCSR = typeof window !== 'undefined'
  const accessPoint = isCSR
    ? (window as Window & { accessPoint?: string })?.accessPoint
    : undefined

  if (
    !Object.keys(clientConfiguration)?.length ||
    !Object.keys(device)?.length ||
    accessPoint === 'APP'
  ) {
    return false
  }

  return (
    clientConfiguration.enabled &&
    device.isMobile() &&
    !device.isBot() &&
    ((device.isAndroid() && !!clientConfiguration.android?.deepLink) ||
      (device.isiOs() &&
        !!clientConfiguration.ios?.appName &&
        !!clientConfiguration.ios?.appStoreUrl))
  )
}

export default clientIsEnabled
